export default __webpack_public_path__ + "static/media/truck_white.5d871dbb.svg";